import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pb-4" }, " Please select a link to join. ", -1)
const _hoisted_2 = {
  class: "form-select mb-4",
  ref: "sel"
}
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("select", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
          return (_openBlock(), _createElementBlock("option", {
            key: link.id,
            value: link.link_url
          }, _toDisplayString(link.name), 9, _hoisted_3))
        }), 128))
      ], 512)
    ]),
    _createElementVNode("button", {
      class: "btn btn-lg btn-success btn-request",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
    }, " Open ")
  ], 64))
}